export var getDisplayName = function (childInput) {
    var _a, _b, _c;
    var child = Array.isArray(childInput) ? childInput[0] : childInput;
    var displayName = ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) || ((_b = child === null || child === void 0 ? void 0 : child.constructor) === null || _b === void 0 ? void 0 : _b.displayName) || (child === null || child === void 0 ? void 0 : child.displayName) || (child === null || child === void 0 ? void 0 : child.name) || ((_c = child === null || child === void 0 ? void 0 : child.constructor) === null || _c === void 0 ? void 0 : _c.name) ||
        'Unknown';
    return displayName;
};
